module.exports = __webpack_public_path__ + "img/22_42.bdaa2572.png";